var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-root"}},[_c('SiteHeader'),_c('main',[_c('router-view')],1),_c('SiteFooter'),_c('div',{staticClass:"rx-toast",class:{ show: _vm.toast.show }},[_vm._v(_vm._s(_vm.toast.msg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }